import EventTypes from 'components/EventTypes';
import AnalyticsEventTypes from 'components/analytics/AnalyticsEventTypes';
import { clearWishlistCache, removeProductFromWishlistCacheByCode } from './WishlistHelpers';

const defaultHideDelayInMs = 200;

/**
 * Wishlist modal (mini wishlist) rendered only on large non-touch devices
 */
class WishlistModal {
  constructor() {
    this.initialize();

    this.hideModal = this.hideModal.bind(this);
    this.hideModalDelayed = this.hideModalDelayed.bind(this);
    this.showModalDelayed = this.showModalDelayed.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.stopDelayedHide = this.stopDelayedHide.bind(this);

    this.bindEvents();
  }

  /**
   * Initialize
   */
  initialize() {
    this.headerWishlistTrigger = document.querySelector('.js-wishlistViewHeaderTrigger');
    this.wishlistModal = document.getElementById('react-wishlist-modal');
    this.isWishlistModalLoaded = /page-wishlist/.test(document.body.className);
  }

  /**
   * Bind listeners
   */
  bindEvents() {
    this.wishlistModal.addEventListener('mouseleave', this.hideModalDelayed);
    this.wishlistModal.addEventListener('mousemove', this.stopDelayedHide);
    this.wishlistModal.addEventListener('mouseenter', this.stopDelayedHide);

    this.headerWishlistTrigger.addEventListener('mouseleave', this.hideModalDelayed);
    this.headerWishlistTrigger.addEventListener('mouseover', this.showModalDelayed);
    this.headerWishlistTrigger.addEventListener('blur', this.hideModal);
    this.headerWishlistTrigger.addEventListener('focus', this.showModal);
    this.headerWishlistTrigger.addEventListener('keydown', event => {
      if (event.code === 'Space') {
        event.preventDefault();
        window.location.href = this.headerWishlistTrigger.href;
      }
    });

    this.headerWishlistTrigger.addEventListener('mouseenter', () =>
      document.jq.trigger(AnalyticsEventTypes.WISHLIST_MODAL_OPEN)
    );

    document.jq.on(EventTypes.WISHLIST_UPDATE_ITEMS, (evt, { isActivatingWishlistIcon, skus }) => {
      // if wishlist modal is loaded, then it is handled by react
      if (this.isWishlistModalLoaded) {
        return;
      }

      if (isActivatingWishlistIcon) {
        clearWishlistCache();
      } else {
        removeProductFromWishlistCacheByCode(skus[0]);
      }
    });

    document.jq.on(EventTypes.LOGIN, clearWishlistCache);
  }

  /**
   * Triggers displaying wishlist modal react app
   */
  displayReactApp() {
    if (this.isWishlistModalLoaded) {
      document.jq.trigger(EventTypes.WISHLIST_MODAL_RERENDER);
    } else {
      this.isWishlistModalLoaded = true;
      window.GSRD.loadAsset(
        ''.concat(window.location.origin).concat(AppSettings.assetPath, 'js/react/wishlist.js')
      );
    }
  }

  /**
   * Closes Wishlist Modal with a delay
   */
  hideModal() {
    this.stopDelayShow();
    this.toggleHideEvents(false);

    document.jq.trigger(EventTypes.WISHLIST_MODAL_HIDE_START);

    this.wishlistModal.classList.remove('is-active');
  }

  /**
   * Closes Wishlist Modal with a delay
   * @param {number} duration
   */
  hideModalDelayed(duration = defaultHideDelayInMs) {
    this.stopDelayedHide();

    this.hideTimerId = window.setTimeout(this.hideModal.bind(this), duration);
  }

  /**
   * Handles displaying animated Wishlist modal
   */
  showModal() {
    this.wishlistModal.classList.add('is-active');
    this.stopDelayShow();

    document.jq.trigger(EventTypes.WISHLIST_MODAL_SHOW_START);

    this.toggleHideEvents(true);
    this.displayReactApp();
  }

  /**
   * Show Wishlist Modal with a delay
   * @param {number} timeout
   */
  showModalDelayed(timeout = 300) {
    this.headerWishlistTrigger.focus();

    if (this.delayShowId === undefined) {
      this.delayShowId = setTimeout(this.showModal.bind(this), timeout);
    }
  }

  /**
   * Stop hiding Wishlist Modal with a delay
   */
  stopDelayedHide() {
    clearTimeout(this.hideTimerId);
  }

  /**
   * Stop show Wishlist Modal with a delay
   */
  stopDelayShow() {
    clearTimeout(this.delayShowId);
    delete this.delayShowId;
  }

  toggleHideEvents(toggle) {
    if (toggle !== this.hideEventsEnabled) {
    }

    this.hideEventsEnabled = toggle;
  }
}

export default new WishlistModal();
